let env = process.env;
export const link = {
  apiService: {
    main: "https://beleaftechnologies.com:3001/",
    // main: "http://localhost:3001"
  },
  siteUrl: env.REACT_APP_FRONTEND,
  adminUrl: env.REACT_APP_ADMIN,
};
